import React, { useState } from 'react';
import { Button, Checkbox, Input, message, Modal } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useProExitFeedback } from '../hooks';

interface IProps {
  visible: boolean;
  onCancel: () => void;
  nextRoute?: string | null;
  setShouldWarn: (warn: boolean) => void;
}

const { TextArea } = Input;

const ExitFeedBackModal: React.FC<IProps> = ({ visible, onCancel, nextRoute, setShouldWarn }) => {
  const t = useTranslations();
  const { push } = useRouter();
  const [selectedReason, setSelectedReason] = useState<string>('');
  const { mutate: sendFeedback, isLoading } = useProExitFeedback();
  const reasons = [t('paymentIssue'), t('premiumConfusion'), t('missingFeatures'), t('technicalIssue'), t('noTrial')];

  const handleCheckboxChange = (checkedValues: string) => {
    setSelectedReason(checkedValues);
  };

  const handleSubmit = async () => {
    if (!selectedReason) return;

    try {
      await sendFeedback(selectedReason);
      setShouldWarn(false);
      onCancel();
      if (nextRoute) push(nextRoute);
    } catch (error) {
      message.error(t('nomalum_xatolik_yuz_berdi'));
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      width="25rem"
      closeIcon={false}
      footer={[
        <Button
          loading={isLoading}
          disabled={!selectedReason}
          key="submit"
          className="!py-4.5 !w-full !border-transparent"
          type="primary"
          onClick={handleSubmit}
        >
          {t('Yuborish')}
        </Button>
      ]}
      centered
    >
      <h1 className="mb-5 text-center text-lg font-medium">{t('Nima_uchun_chiqib_ketdingiz')}</h1>
      <div className="space-y-3">
        {reasons.map(reason => (
          <div
            key={reason}
            className={`flex cursor-pointer items-center rounded-lg p-3 
              ${selectedReason === reason ? 'border-2 border-green-500 bg-green-50' : 'border-2 border-gray-100 hover:border-green-500'}`}
            onClick={() => handleCheckboxChange(reason)}
          >
            <Checkbox
              checked={selectedReason === reason}
              className="[&>.ant-checkbox-inner]:h-8 [&>.ant-checkbox-inner]:w-8 [&>.ant-checkbox-inner]:!rounded-full"
            />
            <span className="ml-3 font-medium text-gray-800">{reason}</span>
          </div>
        ))}
        <TextArea
          //   onFocus={() => setSelectedReason('')}
          className="!border-gray-200 !bg-white hover:!border-green-500 focus:!border-green-500"
          rows={4}
          onChange={e => setSelectedReason(e.target.value)}
          placeholder={`${t('boshqa')}...`}
          maxLength={200}
        />
      </div>
    </Modal>
  );
};

export default ExitFeedBackModal;
